import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// config

// useStyle
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  fontSize: "10px",
  lineHeight: "15px",
  marginBottom: "4px",
  color: "#505050",
}));

const StyledInput = styled(OutlinedInput)(({ theme }) => ({
  width: "160px",
  height: "31px",
  borderRadius: "4px 0 0 4px",
  "& .MuiOutlinedInput-input": {
    borderRadius: 0,
    position: "relative",
    fontSize: "10px",
    width: "auto",
    height: "15px",
    padding: "8px 8px",
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  width: "80px",
  height: "31px",
  borderRadius: "0 4px 4px 0",
  padding: "0",
  "& .MuiOutlinedInput-input": {
    fontSize: "10px",
    padding: "8px 8px",
  },
  "& .MuiList-padding": {
    padding: "0",
  },
  "& .MuiSvgIcon-root": {
    width: "20px",
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "10px",
}));

//
const InputPlusSelect = ({ label, inputProps, selectProps }) => {
  const classes = useStyles();
  // props
  const {
    value: selVal,
    options,
    onChange: onSelectChange,
    ...restSelectProps
  } = selectProps;
  // local state
  const [selectVal, setSelectVal] = useState(selVal || "");

  const handleSelectChange = (e) => {
    setSelectVal(e.target.value);
    if (onSelectChange) onSelectChange(e);
  };

  return (
    <Box>
      {label && <StyledInputLabel>{label}</StyledInputLabel>}
      <Box display="flex">
        <StyledInput {...inputProps} />
        <StyledSelect
          label=""
          // defaultValue=""
          value={selectVal}
          onChange={handleSelectChange}
          {...restSelectProps}
        >
          {Array.isArray(options) &&
            options.map((opt, idx) => (
              <StyledMenuItem key={idx.toString()} value={opt.value}>
                {opt.label}
              </StyledMenuItem>
            ))}
        </StyledSelect>
      </Box>
    </Box>
  );
};

InputPlusSelect.propTypes = {
  label: PropTypes.string,
  inputProps: PropTypes.objectOf(PropTypes.any),
  selectProps: PropTypes.objectOf(PropTypes.any),
};

InputPlusSelect.defaultProps = {
  label: null,
  inputProps: {},
  selectProps: {},
};

export default InputPlusSelect;
